package meineglasfaser.frontend.admin.pages.auth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import meineglasfaser.api.routes.AuthRoutes
import meineglasfaser.frontend.admin.components.AdminUserState
import meineglasfaser.frontend.admin.components.AdminUserStateRedirectIfLoggedOut
import meineglasfaser.frontend.admin.components.GlobalAdminUserState
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.withAuth
import org.jetbrains.compose.web.dom.*

@Page
@Layout(".components.layouts.AdminAuthLayout")
@Composable
fun LogoutPage(ctx: PageContext) {
    AdminUserStateRedirectIfLoggedOut()

    LaunchedEffect(Unit) {
        BackendApi.post(AuthRoutes.RealmAdminPortal.Logout()) {
            withAuth()
        }.fold(
            onSuccess = {
                GlobalAdminUserState.value = AdminUserState.LoggedOut
                Toasts.display(
                    Toast.success("Erfolgreich abgemeldet")
                )
                ctx.router.navigateTo("/auth/login")
            },
            onFailure = { error ->
                Toasts.display(
                    Toast.error("Fehler bei der Abmeldung: ${error.message}")
                )
            }
        )
    }

    Div(attrs = { classes("auth-form")}) {
        H1(attrs = { classes("text-center") }) {
            Text("Abmeldung")
        }
        Div {
            P(attrs = { classes("text-center") }) {
                Span { Text("Sie werden abgemeldet, bitte warten...") }
            }
        }
    }
}
